export default __webpack_public_path__ + "static/media/Anatoli Smorin.2e65e109.jpg";